import React from 'react';
import styled from 'styled-components';

const StyledSection = styled.section`
  font-family: 'Poppins, sans-serif';
  padding: 60px 0;
  background-color: #fff;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
`;

const Col = styled.div`
  flex: 1 0 100%;
  max-width: 100%;
  padding: 0 15px;

  @media(min-width: 768px) {
    flex: 0 0 100%;
  }
`;

const StyledH3 = styled.h3`
  position: relative;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;

  &:before {
    content: '';
    display: block;
    width: 50px;
    height: 4px;
    background: ${({ landingPrimaryColor }) => landingPrimaryColor || '#150080'};
    margin-bottom: 10px;
    border-radius: 2px;
  }
`;

const AboutContent = styled.div`
  font-size: 16px;
  line-height: 1.8;
  color: #333;
`;

const About = ({ aboutUs, landingPrimaryColor }) => {
  if (!aboutUs) return null;

  return (
    <StyledSection id="about-link">
      <Container>
        <Row>
          <Col>
            <div>
              <StyledH3 landingPrimaryColor={landingPrimaryColor}>
                Who We Are
              </StyledH3>
              <AboutContent>{aboutUs}</AboutContent>
            </div>
          </Col>
        </Row>
      </Container>
    </StyledSection>
  );
};

export default About;
